export default __webpack_public_path__ + "static/media/header.30e5510f.png";